import GenericRequest, { METHOD_POST } from '../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../shared/webservices/endpoint';

export class WorkerSearchTask extends GenericRequest {

    _request; // WorkerSearchRequest

    constructor(request) {
        super(METHOD_POST, ApiEndpoints.WORKERS);
        this._request = request;
    }

    overrideRequest() {
        return this._request.body();
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/worker/list/worker-search/WorkerSearchTask.js